"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "@/components/ui/Link";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getSectionUrl, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  title?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  imageMetadata?: ImageMetadata;
  divelement?: FieldConfig;
};
export const VerticalStoryImageCategoryNews = t0 => {
  const $ = _c(27);
  const {
    title: t1,
    imageSrc: t2,
    slug,
    imageMetadata,
    divelement: t3
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? {
      hidden: false,
      value: "\u0BAE\u0B95\u0BB3\u0BBF\u0BB0\u0BCD \u0BAE\u0BA3\u0BBF",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const title = t4;
  let t5;
  if ($[2] !== t2) {
    t5 = t2 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const imageSrc = t5;
  let t6;
  if ($[4] !== t3) {
    t6 = t3 === undefined ? {
      hidden: false,
      value: "",
      customClass: ""
    } : t3;
    $[4] = t3;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const divelement = t6;
  const titleValue = title?.value || "";
  let t7;
  if ($[6] !== imageSrc?.value) {
    t7 = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    $[6] = imageSrc?.value;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const imageSrcValue = t7;
  let t8;
  if ($[8] !== divelement?.customClass || $[9] !== imageMetadata || $[10] !== imageSrc?.customClass || $[11] !== imageSrc?.hidden || $[12] !== imageSrcValue || $[13] !== titleValue) {
    t8 = !imageSrc?.hidden && <div className={`relative w-32 md:w-full aspect-[11/12] overflow-hidden ${divelement?.customClass || ""}`}><Image src={imageSrcValue} alt={titleValue} fill={true} sizes="(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 300px" className={`object-cover w-full h-full ${imageSrc?.customClass || ""}`} style={getFocusPointStyle(imageMetadata)} loading="lazy" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div>;
    $[8] = divelement?.customClass;
    $[9] = imageMetadata;
    $[10] = imageSrc?.customClass;
    $[11] = imageSrc?.hidden;
    $[12] = imageSrcValue;
    $[13] = titleValue;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== title?.customClass || $[16] !== title?.hidden || $[17] !== titleValue) {
    t9 = !title?.hidden && <h3 className={`text-16-tamil-700 leading-5 text-1B1B1B ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[15] = title?.customClass;
    $[16] = title?.hidden;
    $[17] = titleValue;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = <div className="flex flex-col overflow-hidden p-2 md:p-4 gap-2 md:gap-4 items-center">{t8}{t9}</div>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const content = t10;
  if (slug) {
    let t11;
    if ($[22] !== slug) {
      t11 = getSectionUrl(slug);
      $[22] = slug;
      $[23] = t11;
    } else {
      t11 = $[23];
    }
    let t12;
    if ($[24] !== content || $[25] !== t11) {
      t12 = <Link href={t11} className="block  transition-colors cursor-pointer">{content}</Link>;
      $[24] = content;
      $[25] = t11;
      $[26] = t12;
    } else {
      t12 = $[26];
    }
    return t12;
  }
  return content;
};